<div>
	<lib-card [isForm]="true" [title]="'Profile details'">
		<ui-text-form-field
			[title]="'First name'"
			[valueAsSignal]="form.firstName"
			[maxLength]="50"
		></ui-text-form-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Last name'"
			[valueAsSignal]="form.lastName"
			[maxLength]="50"
		></ui-text-form-field>

		<ui-select-item-field
			class="push-top-md"
			[title]="'Gender'"
			[valueAsSignal]="form.gender"
			[items]="genderSelectItems"
		></ui-select-item-field>

		<ui-text-form-field
			class="push-top-md"
			[title]="'Location'"
			[valueAsSignal]="form.location"
			[maxLength]="100"
		></ui-text-form-field>

		<ui-select-item-field
			class="push-top-md"
			[placeholder]="'Select unit...'"
			[title]="'Preferred units'"
			[valueAsSignal]="form.preferredUnit"
			[items]="preferredUnitSelectItems"
		></ui-select-item-field>
	</lib-card>

	<lib-card [isForm]="true" [title]="'Physical information'" class="push-top-md">
		<ui-weight-form-field
			class="push-top-md"
			[unit]="authUser()?.preferredUnit ?? 'metric'"
			[title]="'Weight'"
			[valueAsSignal]="form.weightKg"
		></ui-weight-form-field>

		<ui-height-form-field
			class="push-top-md"
			[title]="'Height'"
			[unit]="authUser()?.preferredUnit ?? 'metric'"
			[valueAsSignal]="form.heightCm"
		></ui-height-form-field>
	</lib-card>

	<lib-card
		[isForm]="true"
		[title]="'Client status'"
		class="push-top-md"
		[subtitle]="'Disabling a client prevents them from accessing the app'"
	>
		<lib-checkbox-form-input
			[label]="'Disable client'"
			[checked]="form.isDisabled()"
			(valueChange)="form.isDisabled.set($event)"
		></lib-checkbox-form-input>
	</lib-card>

	<ui-form-save-button
		class="push-top-md"
		[saveHandler]="saveHandler()"
		[logHandler]="formLogHandler()"
	></ui-form-save-button>

	<lib-card [isForm]="true" [title]="'Danger zone'" class="push-top-md">
		<lib-message [type]="'warning'" [title]="'Warning'">
			Once you delete the client, you will not be able to recover it.
		</lib-message>

		<lib-button
			class="push-top"
			libConfirm
			[confirmMode]="'delete'"
			[confirmText]="'Are you sure to delete the client?'"
			(confirm)="handleDeleteClient()"
			[buttonType]="'delete'"
			[buttonSize]="'large'"
		>
			Delete client
		</lib-button>
	</lib-card>
</div>
